import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div
        data-testid="admin-loader"
        className="min-h-screen w-full flex items-center justify-center"
        style={{ background: "linear-gradient(135deg,#0f172a 0%,#1e293b 100%)", color: "#cbd5e1", fontSize: 14 }}
      >
        Cargando…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

export default AdminRoute;
